import { HardCommuteSettings } from './hard-commute-settings';

import { AUTOMATED_LABEL_KEYS } from '../../../../../util/automated-label-keys';

export const CUSTOM_LABEL_SETTINGS = {
  [AUTOMATED_LABEL_KEYS.IsFarAway]: HardCommuteSettings,
};
